var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"set-title"},[_c('el-dialog',{attrs:{"title":"条形码","visible":true,"width":"360px"},on:{"close":_vm.handleClose}},[_c('js-barcode',{attrs:{"value":_vm.value,"text":_vm.text,"valid":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }